import React from 'react';
import { HStack, Text, Icon, Box } from '@chakra-ui/react';
import { FiCalendar, FiX } from 'react-icons/fi';
import Button from './Button';
import { formatDateRange } from '../../utils/dateUtils';
import { useTranslation } from '../../hooks/useTranslation';

interface DateFilterBarProps {
    dateFilter: { from?: Date; to?: Date } | null;
    onSearchByDate: () => void;
    onClearFilter: () => void;
}

const DateFilterBar: React.FC<DateFilterBarProps> = ({ dateFilter, onSearchByDate, onClearFilter }) => {
    const { t, locale } = useTranslation();

    return (
        <HStack gap={3} align="center" justify="space-between" flexWrap="wrap" flexShrink={0}>
            <Button buttonType="success" size="lg" onClick={onSearchByDate}>
                <HStack gap={3}>
                    <Icon as={FiCalendar} />
                    <Text>{t.pages.mail.searchByDate}</Text>
                </HStack>
            </Button>
            {dateFilter && (dateFilter.from || dateFilter.to) && (
                <HStack gap={2} align="center">
                    <Text fontSize="md" color="gray.500">
                        {formatDateRange(dateFilter.from, dateFilter.to, locale, {
                            dateFrom: t.pages.mail.dateFrom,
                            dateTo: t.pages.mail.dateTo,
                        })}
                    </Text>
                    <Box
                        as="button"
                        onClick={onClearFilter}
                        cursor="pointer"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        color="gray.500"
                        _hover={{ color: 'gray.700' }}
                        aria-label={t.pages.mail.clearFilter}
                    >
                        <Icon as={FiX} boxSize={4} />
                    </Box>
                </HStack>
            )}
        </HStack>
    );
};

export default DateFilterBar;
